$(document).ready(function() {
  $('.product-slider').slick({
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    dots: true,
    asNavFor: '.product-slider-thumbnail'
  });

  // Delay initialization of thumbnail slider
  setTimeout(function() {
    $('.product-slider-thumbnail').slick({
      autoplay: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-slider',
      dots: true,
      arrows: true,
      focusOnSelect: true,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
      ]
    }).on('init', function() {
      $(this).resize(); // Trigger resize event after initialization
    });
  }, 1000); // Adjust the delay time (in milliseconds) as per your requirement
});




